import { Reveal } from "./Reveal";
import { MANIFESTO } from "../lib/content";

export default function Manifesto() {
  return (
    <section id="approach" className="py-24 md:py-32 bg-primary text-primary-foreground relative overflow-hidden">
      <div
        className="absolute -bottom-40 -left-40 w-[34rem] h-[34rem] rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle,#E4C3C9 0%,transparent 70%)" }}
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <Reveal>
          <span className="overline text-secondary">Our approach</span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] mt-5 max-w-2xl">
            Three quiet promises we make to every woman who walks in.
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-10 lg:gap-14">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.12}>
              <div className="border-t border-white/20 pt-6">
                <span className="font-serif text-5xl text-secondary/90">{m.n}</span>
                <h3 className="font-serif text-2xl mt-4 mb-3">{m.title}</h3>
                <p className="text-sm leading-relaxed text-primary-foreground/70">{m.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
